var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    {
      attrs: {
        title: "Schedule this session",
        description:
          "Once scheduled, this session will appear on the assigned therapist's calendar on their 'My Sessions' page.",
        label: "Save schedule",
        disabled: _vm.isDisabledSubmit
      },
      on: {
        "backdrop-close": function($event) {
          return _vm.$emit("close-modal")
        },
        "backdrop-action": _vm.onCreate
      }
    },
    [
      _c(
        "div",
        {
          class: { "overflow-y-auto": _vm.conflictedDates.length },
          style: { width: "40rem", maxHeight: "calc(100vh - 16rem)" }
        },
        [
          _c("div", { staticClass: "px-8 flex flex-col gap-4 mb-4" }, [
            _c(
              "div",
              { staticClass: "flex items-center gap-2" },
              [
                _c("BlIcon", {
                  staticClass: "w-6 h-6",
                  attrs: { icon: "user", color: "slate-6" }
                }),
                _vm._v(" "),
                _c("BlSelectBox", {
                  staticClass: "max-w-136",
                  attrs: {
                    placeholder: _vm.therapistSelectLoading
                      ? "Loading ..."
                      : "Select therapist",
                    options: _vm.therapistOptions,
                    search: ""
                  },
                  on: { change: _vm.onChangeTherapist },
                  model: {
                    value: _vm.therapistInput,
                    callback: function($$v) {
                      _vm.therapistInput = $$v
                    },
                    expression: "therapistInput"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex items-center gap-2" },
              [
                _c("BlIcon", {
                  staticClass: "w-6 h-6",
                  attrs: { icon: "user-square", color: "slate-6" }
                }),
                _vm._v(" "),
                _c("BlSelectBox", {
                  staticClass: "max-w-136",
                  attrs: {
                    options: [
                      {
                        value: _vm.session.client.id,
                        label: _vm.session.client.name
                      }
                    ],
                    disabled: ""
                  },
                  model: {
                    value: _vm.session.client_id,
                    callback: function($$v) {
                      _vm.$set(_vm.session, "client_id", $$v)
                    },
                    expression: "session.client_id"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex items-center gap-2" },
              [
                _c("BlIcon", {
                  staticClass: "w-6 h-6",
                  attrs: { icon: "calendar-blank", color: "slate-6" }
                }),
                _vm._v(" "),
                _c("BlInputDate", {
                  staticClass: "flex-grow",
                  attrs: { input: _vm.startDateInput },
                  on: { changed: _vm.onChangeDate }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex items-center gap-2" },
              [
                _c("BlIcon", {
                  staticClass: "w-6 h-6",
                  attrs: { icon: "clock-outline", color: "slate-6" }
                }),
                _vm._v(" "),
                _c("BlSelectTimeslot", {
                  staticClass: "flex-grow",
                  attrs: {
                    placeholder: _vm.timeSelectLoading
                      ? "Loading..."
                      : "Select timeslot",
                    options: _vm.timeOptions
                  },
                  on: { change: _vm.onChangeTimeSlot },
                  model: {
                    value: _vm.timeInput,
                    callback: function($$v) {
                      _vm.timeInput = $$v
                    },
                    expression: "timeInput"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.conflictedDates.length
              ? _c(
                  "div",
                  {
                    staticClass:
                      "rounded flex items-start gap-2 py-2 px-3 bg-tulip-100"
                  },
                  [
                    _c("BlIcon", {
                      staticClass: "h-6 w-6",
                      attrs: { icon: "warning", color: "tulip-7" }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col w-128" },
                      [
                        _c("BlTextBody2", {
                          staticClass: "text-tulip-700",
                          attrs: { text: _vm.suffixError }
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.conflictedDates, function(date) {
                          return _c(
                            "div",
                            {
                              key: date,
                              staticClass: "flex items-center gap-2 px-2"
                            },
                            [
                              _c("div", {
                                staticClass: "rounded h-1 w-1 bg-tulip-700"
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "text-tulip-700",
                                attrs: { text: date }
                              })
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "text-tulip-700",
                          attrs: {
                            text: "Please adjust the details to proceed."
                          }
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-full h-5 bg-grey-100 mb-4" }),
          _vm._v(" "),
          _c("div", { staticClass: "px-8 pb-8 mb-4" }, [
            _c(
              "div",
              {
                staticClass: "flex items-center mb-2 cursor-pointer",
                on: {
                  click: function($event) {
                    _vm.setAssignSupervisorsInput = !_vm.setAssignSupervisorsInput
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "pl-2 pr-4",
                    style: { transform: "scale(1.375)" }
                  },
                  [
                    _c("BlInputToggle", {
                      attrs: { checked: _vm.setAssignSupervisorsInput },
                      on: {
                        changed: function($event) {
                          _vm.setAssignSupervisorsInput = !_vm.setAssignSupervisorsInput
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("BlTextSubtitle1", { attrs: { text: "Assign supervisor" } })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex mb-4" },
              [
                _c("BlTextBody2", {
                  attrs: {
                    text:
                      "If you assign a supervisor, they will find this session listed in the table view on their 'My Sessions' page."
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.setAssignSupervisorsInput
              ? _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("BlSearchBox", {
                      attrs: {
                        type: "user",
                        placeholder: "Select therapist",
                        options: _vm.assignSupervisorOptions,
                        searching: _vm.assignSupervisorsSelectLoading,
                        drop: "up"
                      },
                      on: {
                        change: function($event) {
                          _vm.assignSupervisorsInput = $event
                        },
                        search: _vm.fetchSupervisors
                      },
                      model: {
                        value: _vm.assignSupervisorsInput,
                        callback: function($$v) {
                          _vm.assignSupervisorsInput = $$v
                        },
                        expression: "assignSupervisorsInput"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b8b1794", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b8b1794","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sessions/draft/NewScheduleModal.vue
// module id = null
// module chunks = 